<template>
    <ion-toolbar>
        <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length">
            <ion-button class="button_back" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
            <ion-button @click="skip" class="pill next-pill-button">
                <span>Skip</span>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <!-- <div class="page_title">
        {{ pageText[userRole].pageTitle }}
      <el-progress v-if="userRole === 'pharmacy'" class="progress" :percentage="55" :show-text="false" color="#2463FF" />
      </div> -->
        <div class="container onboarding">
            <div class="auth-header">
                <div class="auth-heading">
                    <h1>{{ pageText[userRole].pageTitle }}</h1>
                </div>
                <div class="brand-icon">
                    <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
                </div>
            </div>
            <el-form :model="formsData.userForm" :rules="formsData.userForm.rules"
                :ref="(el) => (formsData.userForm.ref = el)" :label-position="'top'" @submit.prevent="save('userForm')">

                <el-form-item :label="hospitalPharmacy2Info?.label ? hospitalPharmacy2Info.label : 'Which Automated Dispensing Cabinets (ADC) do you use?'" prop="automatedDispenseryCabinet"
                    class="onboarding_form_checkbox">
                    <el-select popper-class="normal-select" class="w-100"
                        v-model="formsData.userForm.automatedDispenseryCabinet.value"
                        placeholder="Select Automated Dispensery Cabinet" :popper-append-to-body="true">
                        <el-option v-for="option in hospitalPharmacy2SelectOptions" :key="option.label"
                            :label="option.label" :value="option.label"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item class="button_submit mb0 mt-auto">
                    <el-button class="submit" type="blue" @click="save('userForm')">
                        Continue
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>


<script>
import SvgIcon from '@/components/Svg/SvgIcon.vue';
import { IonButton, IonButtons, IonIcon, IonToolbar } from '@ionic/vue';
import { inject, onMounted } from 'vue';
// import { getCurrentInstance, inject } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import formHooks from '@/hooks/form/form'


export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        SvgIcon
    },
    setup() {
        const $store = useStore();
        const $router = useRouter();
        const $route = useRoute();
        const setPageClassGlobal = inject(["setPageClassGlobal"]);
        // const instance = getCurrentInstance();

        const userData = $store.getters.GET_USER_DATA;
        const userRole = userData.role;
        const { hospitalPharmacy2AdditionalInfo } = $store.getters.pharmacyAdditionalInfo;
        const hospitalPharmacy2Info = hospitalPharmacy2AdditionalInfo?.length > 0 ? hospitalPharmacy2AdditionalInfo[0] : {};
        const hospitalPharmacy2SelectOptions = hospitalPharmacy2AdditionalInfo?.length > 0 ? hospitalPharmacy2AdditionalInfo[0].values : [];


        const pageText = {
            pharmacy: {
                pageTitle: "Automated Dispensing Cabinets (ADC)",
                formText: `Which Automated Dispensing Cabinets (ADC) do you use?`,
            },
        };

        const formsDataArray = {
            userForm: {}
        }

        const dataArray = {
            automatedDispenseryCabinet: {
                value: [],
                resetValue: true,
            },
        }

        Object.assign(formsDataArray.userForm, dataArray);

        const goBack = async () => {
            // const back = await $store.dispatch("getAuthPageBack");
            $router.push({
                name: "hospital_pharmacy_information_1",
            });
        };

        const skip = async () => {
            $store.dispatch("addAuthPageBack", $route.name);
            $router.push({
                name: "intro",
            })
        }

        onMounted(() => {
            setPageClassGlobal('global_community_pharmacy_information')
            // setFormRefs();
        })

        const save = (formName) => {
            formsRefs[formName].value.validate((valid) => {
                if (valid) {
                    (async () => {
                        try {
                            const formValues = getFormValues(formName);
                            const selectedautomatedDispenseryCabinet = formValues.automatedDispenseryCabinet;

                            if (!selectedautomatedDispenseryCabinet) {
                                $router.push({
                                    name: "intro",
                                })
                                return
                            }

                            const payload = [{
                                values: [{ value: selectedautomatedDispenseryCabinet }], // Map selected values
                                key: hospitalPharmacy2Info.key,
                                field_type: hospitalPharmacy2Info.fieldType,
                            }];
                            await $store.dispatch("SAVE_ADDITIONAL_PHARMACY_INFO", payload);
                            $router.push({
                                name: "intro",
                            })

                        } catch (error) {
                            console.error("Error submitting:", error);
                        }
                    })();
                } else {
                    console.log("Form validation failed!");
                    return false;
                }
            });
        };

        onMounted(() => {
            setPageClassGlobal('global_hospital_pharmacy_information');
            setFormRefs(); // Call setFormRefs to initialize formsRefs
        });

        const {
            // onFormMaskAccept,
            checkFormValidation,
            // setFormValidation,
            getFormValues,
            setFormRefs,
            formsData,
            formsRefs,
        } = formHooks(formsDataArray)

        return {
            goBack,
            save,
            pageText,
            userRole,
            hospitalPharmacy2Info,
            hospitalPharmacy2SelectOptions,
            formsData,
            checkFormValidation,
            skip
        }
    }
}
</script>